module.exports = __webpack_public_path__ + "img/my_account_screenshot.png";